import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
  margin: 181px 0 77px;
  width: 1286px;
  align-self: center;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 1024px) {
    width: 100vw;
    justify-content: center;
  }
`;

const Items = styled.div`
  display: flex;
  flex-direction: row;

  .attendee-no-margin {
    margin: 0;
  }

  @media (max-width: 1024px) {
    justify-content: center;
    flex-direction: column;
  }
`;

const Item = styled.div`
  margin: 0 80px 0 0;

  p {
    font-weight: 500;
    font-size: 72px;
  }

  .attendee-type {
    font-size: 24px;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;

    p {
      font-size: 64px;
    }

    .attendee-type {
      font-size: 18px;
    }
  }
`;

const Attendants = () => {
  const { t } = useTranslation();

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Container>
        <Items>
          <Item>
            <p>200+</p>
            <p className="attendee-type">{t('website.partners')}</p>
          </Item>

          <Item>
            <p>850+</p>
            <p className="attendee-type">{t('website.investors')}</p>
          </Item>

          <Item className="attendee-no-margin">
            <p>33 000+</p>
            <p className="attendee-type">{t('website.attendees')}</p>
          </Item>
        </Items>
      </Container>
    </div>
  );
};

export default Attendants;
